export default function Circle() {
  return (
    <svg viewBox="22 22 44 44">
      <circle cx="44" cy="44" r="20.2" fill="none" stroke-width="3.6" />
    </svg>
  );
}
